import React, { useEffect, useState } from "react";
import { message, Switch, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useAccountModel } from "./accountModel";
import { IAccountDetail } from "../../AccountTypes";
import { useDetailModel } from "../detailModel";
import { accountService } from "../../AccountService";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { useGlobalModel } from "@/model/globalModel";
import { globalPrompt } from "@/components/YhMessage";

export function AccountDataTable() {
    const { resourceAuth } = useGlobalModel(model => [model.resourceAuth])
    const {
        dataSource, selectedRowKeys,
        setSelectedRowKeys,
        loadData,
    } = useAccountModel();
    const [loading, setLoading] = useState(false)
    const {
        appDs,
    } = useDetailModel(model => [
        model.appDs
    ])
    const handleChangeStatus = async (status: boolean, code: string) => {
        try {
            setLoading(true)
            let result
            if (status) {
                result = await accountService.allotEnable({ code })
            } else {
                result = await accountService.allotDisable({ code })
            }
            setLoading(false)
            if (result.success) {
                message.success('操作成功！')
                loadData().then()
            } else {
                message.error('操作失败！')
            }
        } catch (error) {
            setLoading(false)
        }
    }
    const columns: ColumnsType<IAccountDetail> = [
        // {
        //     align: "center",
        //     title: '分支',
        //     dataIndex: 'branch',
        //     render: (v) => {
        //         let item = appDs?.find(item => item.value === v)
        //         return item?.label
        //     }
        // },
        {
            align: "center",
            title: '账户编码',
            dataIndex: 'code',
        },
        {
            align: "center",
            title: '账户名称',
            dataIndex: 'name',
        },
        {
            align: "center",
            title: '授信类型',
            dataIndex: 'creditFlag',
            render: (v) => v === 1 ? '记账' : v === 0 ? '现结' : ''
        },
        {
            align: "center",
            title: '账户类型',
            dataIndex: 'accountTypeName',
        },
        {
            align: "center",
            title: '内部核算单位',
            dataIndex: 'unitName',
        },
        {
            align: "center",
            title: '账户实体',
            dataIndex: 'beName',
        },
        {
            align: "center",
            title: '门店',
            dataIndex: 'shopName',
        },
        // {
        //     align: "center",
        //     title: '授信额度',
        //     dataIndex: 'creditAmount',
        // },
        // {
        //     align: "center",
        //     title: '已用额度',
        //     dataIndex: 'usedAmount',
        // },
        // {
        //     align: "center",
        //     title: '可用额度',
        //     dataIndex: 'availableAmount',
        // },
        {
            align: "center",
            title: '欠款',
            dataIndex: 'usedAmount',
            // dataIndex: 'abatementAmount',
        },
        {
            align: "center",
            title: '余额',
            dataIndex: 'remainingAmount',
        },
        {
            align: "center",
            title: '创建人',
            dataIndex: 'createTime',
        },
        {
            align: "center",
            title: '创建日期',
            dataIndex: 'createTime',
        },
        {
            align: "center",
            title: '备注',
            dataIndex: 'note',
        },
        // {
        //     title: '状态',
        //     dataIndex: 'status',
        //     width: 80,
        //     render: (v) => v === 0 ? "正常" : "异常"
        // },
        {
            align: "center",
            title: '账户状态',
            dataIndex: 'status',
            render: (text, record) =>
            (
                <Switch
                    checkedChildren="已启用"
                    unCheckedChildren="已禁用"
                    defaultChecked
                    loading={loading}
                    checked={text === 0}
                    onChange={(v) => handleChangeStatus(v, record.code as string)}
                />
            )
        },

    ];

    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IAccountDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            loading={loading}
            columns={columns}
            dataSource={dataSource}
            // pagination={{
            //     ...pgCfg,
            //     position: ["bottomRight"],
            //     onChange: (pageNum, pageSize) => {
            //         loadData({pageNum, pageSize}).then();
            //     }
            // }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
